/* eslint-disable */
import customModal from "../customModal/customModal.vue";

export default {

    name: "KriDetailsModal",

    components: {
        customModal,
    },

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    emits: ["closeModal"],

};
